const state = {
	affiliateID:
		window.localStorage.getItem("affiliateID") != "undefined"
			? JSON.parse(window.localStorage.getItem("affiliateID"))
			: null,
	affiliateTag:
		window.localStorage.getItem("affiliateTag") != "undefined"
			? JSON.parse(window.localStorage.getItem("affiliateTag"))
			: null,
};

const mutations = {
	SET_AFFILIATE_ID(state, affiliateID) {
		state.affiliateID = affiliateID;
		window.localStorage.affiliateID = JSON.stringify(affiliateID);
	},
	SET_AFFILIATE_TAG(state, affiliateTag) {
		state.affiliateTag = affiliateTag;
		window.localStorage.affiliateTag = JSON.stringify(affiliateTag);
	},
};

const getters = {
	affiliateID(state) {
		return state.affiliateID;
	},
	affiliateTag(state) {
		return state.affiliateTag;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
};
